"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRadioSelection = exports.generateRadios = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const generateRadios = (selected, setSelected, radios, name, selectRadio) => {
  return radios.map((radio, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-radio",
      key: `radio-${index}`
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `radio-button-${index}`,
      type: "radio",
      name: name,
      onChange: () => updateRadioSelection(setSelected, selectRadio, radio, name),
      checked: selected === radio,
      value: radio
      // id={`${name}Choice${index}`}
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: `${name}Choice${index}`,
      className: `ter-radio__label radio-${index}`
    }, radio));
  });
};
exports.generateRadios = generateRadios;
const updateRadioSelection = (setSelected, selectRadio, radio, name) => {
  setSelected(radio);
  selectRadio(radio, name);
};
exports.updateRadioSelection = updateRadioSelection;